var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAskCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#BFBFBF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4471_13797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57841 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z",
    fill: "#currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7632 10.1226C7.32092 10.1226 6.96289 10.4912 6.96289 10.9334C6.96289 11.3652 7.31039 11.7443 7.7632 11.7443C8.21602 11.7443 8.57402 11.3652 8.57402 10.9334C8.57402 10.4912 8.20545 10.1226 7.7632 10.1226Z",
    fill: "#currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89969 3.9834C6.47807 3.9834 5.8252 4.82587 5.8252 5.39449C5.8252 5.80518 6.1727 5.99474 6.45701 5.99474C7.02566 5.99474 6.79401 5.18387 7.8681 5.18387C8.3946 5.18387 8.81585 5.41555 8.81585 5.89996C8.81585 6.46859 8.22613 6.79502 7.87863 7.08987C7.57323 7.35309 7.1731 7.78487 7.1731 8.69049C7.1731 9.23806 7.32054 9.39602 7.75226 9.39602C8.26823 9.39602 8.37354 9.16437 8.37354 8.96424C8.37354 8.41668 8.38407 8.10077 8.96326 7.64796C9.24757 7.42684 10.1426 6.71074 10.1426 5.7209C10.1426 4.73105 9.24757 3.9834 7.89969 3.9834Z",
    fill: "#currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4471_13797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAskCircle);
export default __webpack_public_path__ + "static/media/ic-ask-circle.cbc5785240f80812cec21d143d495414.svg";
export { ForwardRef as ReactComponent };